import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { IconX } from '@tabler/icons';
import colors from '../../util/colors.js';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import Text from '../Text/Text.component.js';
import { propTypes, defaultProps } from './ModalHeader.types.js';
import styles from './ModalHeader.module.scss.js';

var ModalHeader = /** @class */ (function (_super) {
    __extends(ModalHeader, _super);
    function ModalHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalHeader.prototype.render = function () {
        var _a = this.props, className = _a.className, content = _a.content, onRequestClose = _a.onRequestClose, iconAlt = _a.iconAlt, alignCenter = _a.alignCenter;
        var CloseIcon = (React__default.createElement(ButtonBase, { onClick: onRequestClose, type: "button", tabIndex: -1, "data-testid": 'close-button', style: {
                border: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
            }, title: iconAlt, className: styles.ModalHeader_closeIcon },
            React__default.createElement(IconX, { color: colors.black, size: 19 })));
        return (React__default.createElement("div", { className: clsx(styles.ModalHeader, className, alignCenter && styles.ModalHeader___alignCenter) },
            React__default.createElement("div", { className: clsx(styles.HeaderTitle, alignCenter && styles.HeaderTitle___alignCenter, onRequestClose && styles.HeaderTitle___closeIconWidth) }, typeof content === 'string' ? (React__default.createElement(Text, { type: "h5" }, content)) : (React__default.createElement(React__default.Fragment, null, content))),
            onRequestClose && CloseIcon));
    };
    ModalHeader.displayName = 'ModalHeader';
    ModalHeader.propTypes = propTypes;
    ModalHeader.defaultProps = __assign({}, defaultProps);
    return ModalHeader;
}(React__default.Component));

export { ModalHeader, ModalHeader as default };
